import { SELECT_SIZE, UPDATE_STATS, PAUSE, REVEAL } from './actions';
import { SET_CELLS, SET_OVER, UPDATE_TIME } from './actions';
import { SET_INIT } from './actions';
import * as f from '../logic';
import _ from 'lodash';
import { SET_RESTART } from '../../HOME/REDUX/actions';
import { dbdel } from '../../HOME/utils';
import { HELPED_KEY } from '../const';

export default (state = {}, action) => {
  switch (action.type) {
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SET_INIT:
      return { ...state, init: action.init };
    case SET_OVER:
      return { ...state, over: action.over };
    case SET_CELLS:
      return { ...state, cells: action.cells };
    case SET_RESTART:
      return { ...state, restart: action.restart, over: false };
    case UPDATE_TIME:
      return { ...state, msecs: action.msecs };
    case PAUSE:
      return { ...state, paused: action.on };
    case REVEAL:
      return { ...state, revealing: action.on };
    case HELPED_KEY:
      return { ...state, helped: true };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggScore, bestScore } = stats;

    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
